require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#5F5A8B',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
        green: '#158144',
        red: '#D80000',
      },
      dark: {
        primary: '#5F5A8B',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
        green: '#158144',
        red: '#D80000',
      },
    },
  },
}
